jQuery(function() {
  //set default campaign
  var campaign = '';
  var cookieName = "campaign"
  var jsonFileName = window.baseUrl+'/campaigns.json';
  //let's see if we've got a cookie set
  var cookie = jQuery.cookie(cookieName);

  //if so, that's our campaign
  if(cookie) {
    campaign = cookie;
  }

  //let's see if we've got a campaign variable
  var parsedUrl = url.parse(document.location.href);

  var query = parsedUrl.get;

  if(query) {
    var queryCampaign = query.utm_campaign;

    if(queryCampaign) {
      //if so, that's our campaign, overwriting any set cookie
      campaign = queryCampaign;

      //set our cookie to this campaign now
      //expires in 30 days
      jQuery.cookie(cookieName, campaign, { expires: 30, path: '/' });

    }
  }

  //do we have a campaign to look for?

  if(campaign !== '') {
  //go get the campaigns JSON
    var jsonPromise = jQuery.getJSON( jsonFileName);

    jsonPromise
      .then(function(campaigns) {
        //look through the campaigns for one with the campaign name
        var camp = { 'campaign': campaign }
        function equalsCampaignValue(c) {
          return (c == camp);
        }
        whereCampaign = campaigns.filter(equalsCampaignValue);

        if(whereCampaign.length > 0) {
          var phone = whereCampaign[0].phone;

          //replace phone number text

          jQuery('.phone').each(function() {
            this.innerText = phone;
          });

          //replace phone number links
          jQuery('.phoneLink').each(function() {
            var fullPhoneLink = "tel: +1 "+phone;
            jQuery(this).attr('href',fullPhoneLink);
          });							
        }
      })
  }
});